<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path class="custom-icon-path"
              :fill="currentColor"
              :d="icon"></path>
    </svg>
</template>

<script>
export default {
    name: "Icon",
    props: {
        icon: {
            type: String,
            required: true,
        },
        currentColor: {
            type: String,
            required: false,
            default: 'currentColor'
        },
        hoverColor: {
            type: String,
            required: false,
            default: 'initial'
        },
        focusColor: {
            type: String,
            required: false,
            default: 'initial'
        }
    },
}
</script>

<style scoped>
    .custom-icon-path:hover{
        fill: v-bind(hoverColor)
    }
    .custom-icon-path:focus{
        fill: v-bind(focusColor)
    }
</style>
